import React from 'react';
import data from '../db-local/db.json'
import parse from "html-react-parser";

const NotFoundPage = () => {
    return (
        <div className="notFoundPage">
            {
                parse(data.nonFound.content)
            }
        </div>
    );
};

export default NotFoundPage;